import './bigfootbbq/style';
import FormStructure from './bigfootbbq/form_structure';

export default FormStructure;